import { render, staticRenderFns } from "./CRUDFuncionarios.vue?vue&type=template&id=5bd9e2da&"
import script from "./CRUDFuncionarios.vue?vue&type=script&lang=js&"
export * from "./CRUDFuncionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports